export enum ProListFormErrorLabelsEnum {
  RelatedClaimNotFound = 'No related Cargo Claim for this PRO.',
  MultipleRelatedClaims = 'PRO has multiple related Cargo Claims.',
  RelatedClaimNotApproved = 'Related Cargo Claim has not been resolved yet.',
  RelatedClaimWithPendingRebuttal = 'Related Cargo Claim has not been resolved yet.',
}
